import styled from 'styled-components'

export const GlobalSearchTruncatedNoticeWrapperStyled = styled.div`
  margin: ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.medium};
`
